import { makeStyles } from "@material-ui/core/styles";
import WelcomeBg from "Assets/images/welcome-bg.webp";

const useStyles = makeStyles((theme) => ({
  banner: {
    background: `url(${WelcomeBg}) no-repeat`,
    backgroundPosition: "center !important",
    backgroundSize: "cover !important",
    minHeight: 300,
    margin: "-24px 0px -40px",
    [theme.breakpoints.down("xs")]: {
      height: "100%",
      margin: 0,
    },
    "& img": {
      width: 150,
    },
    "& h6": {
      margin: 20,
    },
  },
}));

export default useStyles;
